/**
 * Created by yz on 2017/3/27.
 */
{
    angular
        .module("dataModule")
        .factory("request.file", file);
    file.$inject = ['$q',"requestHandler","utils.constant"];
    function file($q,requestHandler,constant) {
        let collect={
            'getUploadResult':getUploadResult
        }
        return collect;

        function getUploadResult(){
            let def=$q.defer();
            
            requestHandler.simpleRequest(constant.action.uploadResult,'')
            .then(function(respone){
                    console.log('得到了最后上传的结果', respone);
                    let fileData={
                        'docId':respone.data[0].docid,
                        'printId':respone.data[0].printid,
                        'fileName':respone.data[0].filename,
                        'pageNum':respone.data[0].pagenum,
                        'uploadDate':Date.parse(respone.data[0].uploaddate)
                    }
                    let resultData={
                        'result':respone.data[0].result,
                        'fileData':fileData
                    }

                    def.resolve(resultData);
                    
                });
            return def.promise;
        }
        
    }

}